import { useTranslation } from 'react-i18next'
import { cn } from '@ludus/ui'
import type { SyncRun } from '@/lib/api/sources.ts'

interface SyncProgressProps {
  run: SyncRun
  className?: string
}

/** `run.total` is unfilled until an adapter can report a board's size before reading it. */
export function SyncProgress({ run, className }: SyncProgressProps) {
  const { t } = useTranslation()
  const pct = run.total && run.total > 0 ? Math.min(100, (run.processed / run.total) * 100) : null

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <div
        className="h-1 w-full overflow-hidden rounded-full bg-border"
        role="progressbar"
        aria-valuenow={pct ?? undefined}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={t('pages.pipelines.sync.progressLabel', { defaultValue: 'Sync progress' })}
      >
        <div
          className={cn('h-full rounded-full bg-primary', pct === null && 'sync-indeterminate')}
          style={pct === null ? undefined : { width: `${pct}%` }}
        />
      </div>
      <p className="text-[11px] text-muted">
        {t('pages.pipelines.sync.counter', {
          processed: run.processed,
          defaultValue: 'Synced {{processed}} so far…',
        })}
      </p>
    </div>
  )
}
